import React from "react";
import { NumericFormat } from 'react-number-format';
import { getOverride } from "../helpers";

const Ballot = ({ votes, options, votesCast, thereIsAWinner }) => {
  const ballotVotes = votes.map((vote, index) => {
    const name = getOverride(vote, "name");
    const votes = getOverride(vote, "votes");
    const winner = getOverride(vote, "winner");

    const percentOfVotes = getOverride(vote, "percentage") ||
      (votesCast > 0 ? ((votes / votesCast) * 100).toFixed(0): 0);

    return (
      <div
        className={
          "grid-row" +
          (options.showPercentOfVotes ? "" : " no-percentage") +
          (thereIsAWinner && winner ? " winner": "") +
          (thereIsAWinner && !winner ? " loser": "")
        }
        key={index}
      >
        <div className="ballot-wrapper">
        <div className="ballot-info">{name}</div>
        <div className="ballot-container">
          <div className="ballot-votes"><NumericFormat value={votes} displayType={'text'} thousandSeparator={true} /> votes</div>
          {options.showPercentOfVotes && (
            <div className="ballot-percentage progress-bar-percentage">{percentOfVotes}%</div>
          )}
          </div>
        </div>
        <div className="ballot-votes-percentage progress-bar-and-percentage-container">
          <div className="progress-wrapper">
            <progress max={votesCast} value={votes} />
          </div>
        </div>
      </div>
    );
  });

  return ballotVotes;
};

export default Ballot;
